<script lang="ts" setup>
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Application } from "@/types/order/Application";
import WorkInfoTable from "@/views/applications/organisms/WorkInfoTable.vue";

defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
});

const emits = defineEmits(["finishWork", "close"]);

function finishWork() {
  emits("finishWork", true);
}
function onClose() {
  emits("close");
}
</script>

<template>
  <BModal
    :visible="visible"
    title="退勤後、勤怠変更申請が必要です"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
    @hide="onClose"
  >
    <div class="px-2 pb-2">
      <p>お仕事お疲れ様でした！</p>
      <p class="text-danger">
        遅刻または早退が発生しています
      </p>
      <p class="text-danger">
        退勤後、勤怠変更申請してください
      </p>
      <div class="my-4">
        <WorkInfoTable :application="application" />
      </div>
      <p>
        給与は勤怠変更申請が承認され次第、申請内容をもとにウォレットに反映されます
      </p>
      <AppButton block @click="finishWork" class="d-block mt-3">
        退勤後、勤怠変更申請する
      </AppButton>
    </div>
  </BModal>
</template>
